function Directive() {
  "ngInject";
  // eslint-disable-next-line max-len
  return {
    scope: { trigger: "=focusInput" },
    link(scope, element) {
      scope.$watch("trigger", (value) => {
        if (value === true) {
          // Console.log('trigger',value);
          // $timeout(function() {
          element[0].focus();
          scope.trigger = false;
          // });
        }
      });
    },
  };
}

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/focusInput/focusInput.directive.js